export default __webpack_public_path__ + "static/media/Image-11.58c49e45.jpg";